import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { contactInfo } from '../mock';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // make sure path is correct
const API = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'success' | 'error'
  
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading'); // optional loading state

    try {
      await addDoc(collection(db, "newsletterSubscriptions"), {
  email,
  source: "Website Footer",
  createdAt: serverTimestamp()
});

// 🔥 CALL FASTAPI EMAIL
await fetch(`${API}/send-newsletter-email`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({ email }),
});


      // Success
      setStatus('success');
      setEmail('');

      // Clear status after 3s
      setTimeout(() => setStatus(null), 3000);

    } catch (error) {
      console.error("Newsletter Firebase Error:", error);
      setStatus('error');
    }
  };

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Projects', path: '/projects' },
    { name: 'About Us', path: '/about' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' }

  ];

  const legalLinks = [
  { name: 'Privacy Policy', path: '/privacy-policy' },
  { name: 'Terms of Service', path: '/terms-of-service' },
  { name: 'Approvals & Legal', path: '/approvals' }
];


  return (
    <footer className="bg-brand-dark text-white pt-16 pb-8">
      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <img
  src="/DVV Projects Logo.png"
  alt="DVV Projects"
  className="h-16 mb-4"
/>

            <p className="text-gray-300 text-sm mb-4">
              Delivering Value & Vision in Visakhapatnam's real estate sector with VMRDA & RERA approved properties.
            </p>
            <div className="flex space-x-4">
              <a
                href={contactInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-brand-gold transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-brand-gold transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
  <h3 className="font-bold text-lg mb-4">Quick Links</h3>

  <div className="grid grid-cols-2 gap-8">

  {/* Column 1 */}
  <ul className="space-y-2 text-sm">
    <li>
      <Link to="/" className="text-gray-300 hover:text-brand-gold transition-colors">
        Home
      </Link>
    </li>
    <li>
      <Link to="/gallery" className="text-gray-300 hover:text-brand-gold transition-colors">
        Gallery
      </Link>
    </li>
    <li>
      <Link to="/about" className="text-gray-300 hover:text-brand-gold transition-colors">
        About Us
      </Link>
    </li>
    <li>
      <Link to="/contact" className="text-gray-300 hover:text-brand-gold transition-colors">
        Contact
      </Link>
    </li>
  </ul>

  {/* Column 2 */}
  <ul className="space-y-2 text-sm">
    
    {/* Parent */}
    <li className="ml-3">
      <Link
        to="/projects"
        className="text-gray-300 hover:text-brand-gold transition-colors">
        Projects
      </Link>
    </li>

    {/* Children */}
    <li className="ml-3">
      <Link
        to="/projects?type=residential"
        className="text-gray-300 hover:text-brand-gold transition-colors">
        Residential
      </Link>
    </li>

    <li className="ml-3">
      <Link
        to="/projects?type=farmland"
        className="text-gray-300 hover:text-brand-gold transition-colors">
        Farmland
      </Link>
    </li>

  </ul>




  </div>
</div>



          {/* Contact Info */}
<div>
  <h3 className="font-bold text-lg mb-4">Contact Us</h3>

 <ul className="space-y-4 text-sm">
  {/* Address */}
  <li className="space-y-5">
  {/* Head Office */}
  <div className="flex items-start gap-3">
    <MapPin
      size={18}
      className="text-brand-gold mt-1 flex-shrink-0"
    />

    <div className="text-gray-300">
      <p className="font-semibold text-white">Head Office</p>
      <p className="leading-6 whitespace-pre-line">
        {contactInfo.addresses.headOffice}
      </p>
    </div>
  </div>

  {/* Branch Office */}
  <div className="flex items-start gap-3 border-t border-white/10 pt-4">
    <MapPin
      size={18}
      className="text-brand-gold mt-1 flex-shrink-0"
    />

    <div className="text-gray-300">
      <p className="font-semibold text-white">Branch Office</p>
      <p className="leading-6 whitespace-pre-line">
        {contactInfo.addresses.branchOffice}
      </p>
    </div>
  </div>
</li>

  {/* Phone */}
  <li className="flex items-center gap-3">
    <Phone
      size={18}
      className="text-brand-gold flex-shrink-0"
    />
    <a
      href={`tel:${contactInfo.phone}`}
      className="text-gray-300 hover:text-brand-gold transition-colors"
    >
      {contactInfo.phone}
    </a>
  </li>

  {/* Email */}
  <li className="flex items-center gap-3">
    <Mail
      size={18}
      className="text-brand-gold flex-shrink-0"
    />
    <a
      href={`mailto:${contactInfo.email}`}
      className="text-gray-300 hover:text-brand-gold transition-colors"
    >
      {contactInfo.email}
    </a>
  </li>

  {/* Business Hours */}
  <li className="flex items-center gap-3">
    <Clock
      size={18}
      className="text-brand-gold flex-shrink-0"
    />
    <span className="text-gray-300">
      {contactInfo.businessHours}
    </span>
  </li>
</ul>
</div>

          {/* Newsletter */}
          <div>
            <h3 className="font-bold text-lg mb-4">Stay Updated</h3>
            <p className="text-gray-300 text-sm mb-4">
              Subscribe to get updates on new projects and offers.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-3">
              <Input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-white/10 border-white/20 text-white placeholder:text-gray-400"
              />
              <Button
                type="submit"
                className="w-full btn-primary"
                disabled={status === 'loading'}
              >
                {status === 'loading'
                  ? 'Submitting...'
                  : status === 'success'
                  ? 'Subscribed!'
                  : 'Subscribe'}
              </Button>
              {status === 'error' && (
                <p className="text-red-500 text-sm mt-1">
                  Something went wrong. Please try again.
                </p>
              )}
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} DVV Projects. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              {legalLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-gray-400 hover:text-brand-gold transition-colors text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
